<template>
	<div class="chat-container w-100 position-relative" style="margin-bottom: -60px;">
    <div id="hotel-check-in"></div>
    <div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="">
                  <div class="w-100 bg-green box-shadow-nav p-3">
                    <div class="row">
                      <div class="col-8 text-left">
                        <p class="mb-0 ml-2 body-1-2 font-semibold text-white">{{$t('hotel.concierge.pre-checkin-form')}}</p>
                      </div>
                      <div class="col-4 text-right">
                        <div @click="toggleLanguage(true)" style="top:0px !important">
                          <template v-for="data in getMerchant().language">
                            <template v-if="data.iso_code == getCurrentLanguage()">
                              <img :src="data.image_url" class="p-0 language border" style="top: 0px;">
                              <i class="language-i text-right text-white simple-icon-arrow-down" style="top: 0px;"></i>
                            </template>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="height-50px"></div>
    <!-- LANGUAGE -->
    <transition name="list">
      <Language v-if="language" :data="true" @toggleLanguage="toggleLanguage"></Language>
    </transition>
    <!-- TERM CONDITION -->
    <transition name="list">
      <TermCondition v-if="term_conditions_data" @toggleTermCondition="togglePopUp"></TermCondition>
    </transition>
    <!-- POP UP BG -->
    <popUpBG v-if="language || term_conditions_data"></popUpBG>
    <template v-if="is_load_room">
      <loader />
    </template>
    <template v-else>
      <div v-if="error != ''" class="px-3 py-2 border radius-0 text-center d-block mt-5 mx-4" style="background-color: rgb(255, 246, 243); border-color: rgb(254, 207, 184) !important;">
        <p class="mb-0 body-2-1 w-75 mx-auto">{{error}}</p>
      </div>
      <template v-else>
        <div v-if="$route.query.folio == undefined" class="container px-4 pt-4 bg-light-desktop border-x-semi-grey">
          <CheckinData :data="header_data" :show_room="true"></CheckinData>
        </div>
      </template>
    </template>
    <span id="general-form"></span>
    <div class="container pt-4 px-4" :class="form_step==1?'bg-white':'border-x-semi-grey bg-light-desktop'">
      <template v-if="show_form">
        <div v-show="form_step == 1">
          <GeneralForm @fillData="fillData" :guest="selected_room.booked_by" :error="invalid_form" :show_error="show_error_msg" :is_auto_fill="selected_room.is_precheckin_autofill" />
          <span id="img-form"></span>
          <UploadPassport 
            ref="img_form" 
            v-if="getMerchant().precheckin_form_document_verification != 'HIDE' && $route.query.folio == undefined" @fillData="fillData" 
            :max_guest="total_max_guest" :error="invalid_form" 
            :show_error="show_error_msg">
          </UploadPassport>
          
          <!-- PREFERENCE -->
          <div class="border-top pt-4" v-if="preference_list.length > 0 && getMerchant().guest_profile_preference_position === 'FIRST_PAGE'" id="preference_first_page">
            <UserPreference v-if="!preference_load" :key="preference_key" :question="preference_list" @sendBackAnswer="savePreferenceAnswer" @previousStep="previousStepFromPreference"></UserPreference>
          </div>
          
          
            
          <!-- SIGNATURE -->
          <span id="term-form"></span>
          <template v-if="getMerchant().precheckin_form_signature != 'HIDE'">
            <p class="mb-3 body-2-2 text-14 font-bold border-top pt-4">{{$t('merchant.term-condition')}}</p>
            <p class="mb-2 body-2-1 font-regular">{{$t('merchant.signature')}}<span class="text-danger"  v-if="getMerchant().precheckin_form_signature == 'REQUIRED'">*</span></p>
            <div class="w-100 rounded box-shadow overflow-hidden" style="height: 200px"
            :class="invalid_signature == '' ? 'border-2-solid-light mb-2' : 'border border-danger mb-1' ">
              <vueSignature ref="signature" :sigOption="option" :w="'560px'" :h="'200px'" class="object-fit" style="max-width: 560px;max-height: 200px;"></vueSignature>
            </div>
            <p class="mb-2 body-3-3-1 text-danger" v-if="invalid_signature != ''">{{$t('warning-message.precheckin.required-signature')}}</p>
            <div class="mt-3 mb-4 text-right border-bottom pb-4">
              <button type="button" class="button-black text-12 px-3 py-2 ml-2" @click="undoSignature()">{{$t('merchant.undo')}}</button>
              <button type="button" class="button-secondary px-3 py-2 text-12 ml-2" @click="clearSignature()">{{$t('hotel.clear')}}</button>
            </div>
          </template>

          <!-- TERMS & CONDITIONS -->
          <div class="row no-gutters mb-3" v-if="getMerchant().use_precheckin_terms_and_conditions">
            <div class="col-1">
              <div class="checkbox-wrapper-46">
                <input class="inp-cbx" id="tnc_cbx" v-model="term_conditions" type="checkbox" />
                <label class="cbx" for="tnc_cbx"><span>
                  <svg width="12px" height="10px" viewbox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                  </svg></span>
                </label>
              </div>
            </div>
            <div class="col-11 mb-2">
              <template v-if="getMerchant().precheckin_terms_and_conditions_display_type == 'POPUP'">
                <p class="mb-0 body-2-2 font-regular d-inline-block cursor-pointer"><span @click="termCondition()">{{$t('hotel.accepted-term-condition')}} </span><span class="underline" @click="togglePopUp(true)">{{$t('merchant.term-condition')}}.</span></p>
              </template>
              <template v-if="getMerchant().precheckin_terms_and_conditions_display_type == 'INLINE'">
                <div class="body-2-2 text-14 font-regular html-desc" v-html="$isNotEmpty(getMerchant().precheckin_terms_and_conditions) ? getMerchant().precheckin_terms_and_conditions : getMerchant().terms_and_conditions">
                </div>
              </template>
            </div>
            <div class="col-12">
              <p class="mb-1 body-3-3-1 text-danger" v-if="show_error_msg && !term_conditions">{{$t('warning-message.precheckin.required-term')}}</p>
            </div>
          </div>
                    
          <!-- MARKETING EMAIL -->
          <div class="row no-gutters mb-5 position-relative">
            <div class="col-1">
              <div class="checkbox-wrapper-46">
                <input class="inp-cbx" id="marketing-cbx" v-model="marketing" type="checkbox" />
                <label class="cbx" for="marketing-cbx"><span>
                  <svg width="12px" height="10px" viewbox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                  </svg></span>
                </label>
              </div>
            </div>
            <div class="col-11">
              <p class="mb-0 body-2-2 font-regular d-inline-block cursor-pointer" @click="toggleMarketing()">{{$t('merchant.marketing')}}</p>
            </div>
          </div>    
        </div>
        <div v-if="form_step == 2" id="preference_second_page">
          <UserPreference :question="preference_list" @sendBackAnswer="savePreferenceAnswer" @previousStep="previousStepFromPreference"></UserPreference>
        </div>
        <div class="pb-4">
          <ErrorMessage v-if="error != ''" :message="error" />
          <div class="row slim-grid-row">
            <div class="col-5" v-if="form_step == 2 && show_preference_button">
              <state-button :click="submitFormWithoutPreference" :disabled="pushing_data" variant="secondary-outline" size="lg" block>Skip this step</state-button>
            </div>
            <div :class="form_step == 2 && show_preference_button ? 'col-7' : 'col-12'">
              <state-button :click="submitForm" :disabled="pushing_data" variant="primary" size="lg" block>{{primary_button_text}}</state-button>
            </div>
          </div>
        </div>
      </template>
   	</div>

    <!-- WARNING -->
    <popup-detail 
      id_ref="warning"
      direction="bottom" 
      :show="warning.show"
      use_max_size
      wrapper_size="mobile"
      use_footer
      no_close_backdrop
      @close="toggleWarning">
      <template v-slot:body>
        <div class="py-5 px-4 text-center">
          <div class="rounded-100 my-2 w-20 mx-auto">
            <div class="bg-green rounded-100 mx-auto size-icon-in" :class="warning.title == 'Invalid URL'?'bg-danger':'bg-green'">
              <img v-if="warning.title == 'Invalid URL'" src="../../../assets/img/icon/close-white.png" width="40" style="margin: 20px 20px">
              <img v-else src="../../../assets/img/icon/correct-white.png" width="40" style="margin: 20px 20px">
            </div>
          </div>
          <p class="mb-0 body-2-2 text-18 text-green font-extrabold" :class="warning.title == 'Invalid URL'?'text-danger':'text-green'">{{warning.title}}</p>
          <p class="mb-2 body-2-2">{{warning.body}}</p>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-3 pt-3">
          <template v-if="warning.type == 'active_rev'">
            <div class="row slim-grid-row">
              <div class="col-6">
                <button 
                  @click="goToHomePage"
                  class="g-btn g-btn-dark g-btn-lg w-100" >
                  Cancel
                </button>
              </div>
              <div class="col-6">
                <state-button size="lg" variant="primary" block :click="changeReservation">
                  Yes, Countinue
                </state-button>
              </div>
            </div>
          </template>
          <button 
            v-else
            @click="goToHomePage"
            class="g-btn g-btn-primary g-btn-lg w-100" >
            Homepage
          </button>
        </div>
      </template>
    </popup-detail>

    <!-- SUCCESS -->
    <popup-detail 
      id_ref="show_message_success"
      direction="bottom" 
      :show="show_message_success"
      use_max_size
      wrapper_size="mobile"
      use_footer
      no_close_backdrop
      @close="toggleSuccessMessage">
      <template v-slot:body>
        <div class="py-5 px-4 text-center">
          <div class="rounded-100 my-2 w-20 mx-auto">
            <div class="bg-green rounded-100 mx-auto size-icon-in">
              <img src="../../../assets/img/icon/correct-white.png" width="40" style="margin: 20px 20px">
            </div>
          </div>
          <p class="mb-0 body-2-2 text-18 text-green font-extrabold">{{ getMerchant().precheckin_submit_landing_page_title }}</p>
          <p class="mb-2 body-2-2">{{ getMerchant().precheckin_submit_landing_page_description }}</p>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-3 pt-3">
          <router-link :to="`/${getMerchant().code}`">
            <button 
              class="ga-btn-primary-lg" >
              Close
            </button>
          </router-link>
        </div>
      </template>
    </popup-detail>
    
    <!-- OTHER FOLIO (ARCHIVE) -->
    <transition name="list">
      <div class="popup-box popup-box-bg" v-if="show_success_submit_other_folio">
        <div class="position-relative" >
          <div class="row no-gutters justify-content-center">
            <div class="fixed-top d-block nav-bottom">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="bg-white hide-scroll overflow-scroll">
                      <div class="w-100">
                        <div class="mt-12">
                          <div class="p-3 popup-box-bg">
                            <div class="pop-up-warning bg-white box-shadow-1 rounded">
                              <div class="pt-3 pb-2 px-1 border-bottom">
                                <p class="text-center body-1-1 px-4 text-black mb-0">{{$t('hotel.action.submit-status')}}</p>
                              </div>
                              <div class="w-100 p-4">
                                <div class="py-3 px-2 border radius-0 d-block mb-4" style="background-color: rgb(243, 255, 244); border-color: rgb(193, 254, 184) !important;">
                                  <div class="row no-gutters">
                                    <div class="col-2 align-self-center">
                                      <div class="bg-green p-2 rounded-100 d-table mx-auto" style="line-height: 0 !important">
                                        <img src="../../../assets/img/icon/correct-white.png" width="15" class="position-relative">
                                      </div>
                                    </div>
                                    <div class="col-10 align-self-center">
                                      <div class="mx-2">
                                        <p class="mb-0 text-green body-2-4">{{$t('hotel.concierge.success-submit-precheckin.title')}}</p>
                                        <p class="mb-0 body-2-2">{{$t('hotel.concierge.success-submit-precheckin.desc')}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <button class="button-primary w-100" @click="goToHomePage">
                                  {{$t('hotel.concierge.success-submit-precheckin.action')}}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
	</div>
</template>
<script>
 	import {mapGetters,mapMutations} from 'vuex';
  import {post,get} from '@/services/index.js';
 	import CheckinData from '@/components/hotel/concierge/checkin/CheckinData'
  import RoomList from '@/components/hotel/concierge/checkin/RoomList'
  import UploadPassport from '@/components/hotel/concierge/checkin/UploadPassport'
 	import GeneralForm from '@/components/hotel/concierge/checkin/GeneralForm'
  import WarningBox from '@/components/general/WarningBox'
  import Language from '@/components/hotel/concierge/general/Language'
  import TermCondition from '@/components/hotel/concierge/general/termCondition'
  import popUpBG from '@/components/hotel/concierge/general/popUpBG'
  import UserPreference from '@/components/hotel/concierge/checkin/Preference'
  import vueSignature from "vue-signature"
  import { validationMixin } from "vuelidate";
  const { required, email,minLength } = require("vuelidate/lib/validators");
  import moment from 'moment'

	export default{
		components:{
			CheckinData,
			RoomList,
      UploadPassport,
      GeneralForm,
      WarningBox,
      Language,
      popUpBG,
      vueSignature,
      TermCondition,
      UserPreference
		},
    metaInfo(){
      return {
        title: 'Pre Check-in Form',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
		data(){
			return {
        show_form: false,
        general_form: {},
        passport_list: [],
        owner_image: {
          file:{
            name: ''
          }
        },
        total_guest_selected: 0,
        selected_room: {},
        is_load_room: true,
        error: '',
        header_data: {},
        is_passport_list_valid: false,
        push_loading: false,
        reservation_active: false,
        active_room_type: '',
        show_success_submit_other_folio: false,
        language: false,
      // SIGNATURE
        option:{
          penColor:"rgb(0, 0, 0)",
          backgroundColor:"rgb(255,255,255)"
        },
        term_conditions: false,
        term_conditions_data: false,
        marketing: true,
        signature_image: '',
        invalid_form: {
          first_name: '',
          nationality: '',
          day_of_birth: '',
          id_card_number: '',
          id_card_expired_date: '',
          phone_number: '',
          email: '',
          address: '',
          town: '',
          post_code: '',
          country: '',
          visit_purpose: '',
          source_of_merchant_information: '',
          allergy: '',
          next_destination: '',
          img: '',
          owner_img: ''
        },
        invalid_signature: '',
        show_error_msg: false,
        warning:{
          show: false,
          title: '',
          body: '',
          type: 'default'
        },
        show_message_success: false,
        preference_list: [],
        preference_load: true,
        preference_key: 0,
        form_step: 1,
        pushing_data: false,
        total_max_guest: 0
      }
		},
    mixins: [validationMixin],
    validations: {
      general_form:{
        first_name:{
          required
        },
        nationality:{
          required
        },
        day_of_birth:{
          required
        },
        id_card_number:{
          required
        },
        id_card_expired_date:{
          required
        },
        phone_number:{
          required,
          minLength: minLength(6),
        },
        email: {
          required,
          email
        },
        address:{
          required
        },
        town:{
          required
        },
        postcode:{
          required
        },
        country:{
          required
        },
        visit_purpose:{
          required
        },
        source_of_merchant_information:{
          required
        },
        allergy:{
          required
        },
        next_destination:{
          required
        }
      }
    },
    computed:{
      is_general_form_valid(){
        let valid_data = Object.keys(this.invalid_form).some(key => !(key == 'img' || key == 'owner_img') && this.invalid_form[key] != '');
        return !valid_data
      },
      is_form_valid(){
        let general_valid = this.is_general_form_valid
        if(this.getMerchant().use_precheckin_terms_and_conditions) general_valid = this.is_general_form_valid && this.term_conditions
        
        
        if(this.$route.query.folio != undefined){
          return general_valid
        }else{
          let img_valid = this.invalid_form.img == ''
          let img_owner_valid = this.invalid_form.owner_img == ''

          let all_valid = general_valid  && img_valid && img_owner_valid
          return all_valid
        }
      },
      auth(){
        return this.$route.query
      },
      show_preference_button(){
        let data_exist = this.preference_list.length > 0
        let is_position_second_page = this.getMerchant().guest_profile_preference_position === 'SECOND_PAGE'
        let is_form_required = !this.getMerchant().is_guest_profile_preference_required

        return data_exist && is_position_second_page && is_form_required ? true : false
      },
      primary_button_text() {
        let text = this.$t('hotel.action.confirm-checkin')
        let data_exist = this.preference_list.length > 0
        let pref_pos = this.getMerchant().guest_profile_preference_position
        if(this.form_step == 1 && data_exist && pref_pos == 'SECOND_PAGE') text = this.$t('general.continue')
        return text
      }
    },
		mounted(){
			window.addEventListener('scroll', this.updateScroll)
      this.validateReservationData()
      this.loadPreferenceList()
		},
		methods:{
			...mapGetters(['getMerchant','getConciergeAuth','getCurrentLanguage','getMetaTitleTemplate','isNotLogin','getReservationActive']),
      ...mapMutations(['setConciergeAuth','resetConciergeAuth','setReservationActive']),
      // LOAD
      validateReservationData(){
        this.is_load_room = true
        let valid_url = {
          detail_id: this.$route.params.pms_detail_id ? true : false,
          booking_number: this.auth.booking_number ? true : false,
          token: this.auth.token ? true : false
        }
        if(valid_url.detail_id && valid_url.booking_number && valid_url.token){ 
          let is_vuex_have_rsv = this.getReservationActive().booking_number != '' && this.getReservationActive().detail_id != ''
          let is_rsv_same_with_vuex =  this.getReservationActive().booking_number == valid_url.booking_number && this.getReservationActive().detail_id == valid_url.detail_id

          if(!is_vuex_have_rsv || (is_vuex_have_rsv && is_rsv_same_with_vuex)){
            this.loadRsvWithPMSDetailId(this.$route.params.pms_detail_id)
            .then(res=>{
              if(res.status == 'NEW_RESERVATION'){
                this.setupReservationDataForPage(res)
              }else{
                this.toggleWarning()
                this.warning.title = 'Invalid Reservation Status'
                this.warning.body = 'This reservation has completed the online check-in form data. For more details, please ask our staff'
              }
            }).catch(err=>{
              this.error = err
              this.is_load_room = false
            })
          }else{
            this.loadRsvWithPMSDetailId(this.getReservationActive().detail_id).then(vuex_res=>{
              let is_invalid_status = vuex_res.status == 'CHECKOUT' || vuex_res.status == 'CANCELLED'
              if(is_invalid_status){
                this.setReservationActive('reset')
                this.validateReservationData()
              }else{
                this.warning.title = this.$t('warning-message.active-reservation.title')
                this.warning.body = `${this.$t('warning-message.active-reservation.desc_1')}${vuex_res.room.name ? vuex_res.room.name : '-'}${this.$t('warning-message.active-reservation.desc_2')}`
                this.warning.type = 'active_rev'
                this.toggleWarning()
              }
            }).catch(vuex_err=>{
              this.setReservationActive('reset')
              this.validateReservationData()
            })
          }
        }else{
          this.toggleWarning()
          this.warning.title = 'Invalid URL'
          this.warning.body = 'You visit the wrong url, you will be redirected to the main page'
        }
      },
      loadRsvWithPMSDetailId(detail_id){
        return new Promise((success,fail)=>{
          get("CONCIERGE",`reservation/${detail_id}`,{
            merchant_id: this.getMerchant().id
          }).then(response=>{
            if(response.data.success){
              success(response.data.data)
            }else{
              fail(response.data.message)
            }
          })
        })
      },
      setupReservationDataForPage(data){
        this.selected_room = data
        if(this.selected_room.room_type){
          this.$logout()
          this.total_max_guest = this.getMerchant().precheckin_form_total_document_verification == 'BASED_ON_TOTAL_GUEST' ? Number(data.adult)+Number(data.child) : Number(this.selected_room.room_type.max_guests)
          this.header_data = {
            merchant: this.getMerchant(),
            detail:{
              check_in: data.arrival_date,
              check_out: data.departure_date,
              adult: data.adult,
              child: data.child,
              special_request: data.special_request
            },
            guest: data.booked_by,
            total_rooms: 0,
            room_type: this.$isNotEmpty(data.room_type) ? data.room_type.name : 'Unallocated Room Type' ,
            room: this.$isNotEmpty(data.room) ? data.room.name : 'Unallocated Room' ,
            rate: this.$isNotEmpty(data.rate) ? data.room.name : '-' ,
          }
          this.show_form = true
          this.is_load_room = false
        }else{
          throw new Error("Room type has not been mapped.");
        }
      },
      loadPreferenceList(){
        this.preference_load = true
        get('CORE_HOTEL',`merchant/${this.getMerchant().id}/guest-profile-preference`).then(response=>{
          let res = response.data
          if(res.success){
            this.preference_list = res.data
            this.preference_list = this.preference_list.map((y,i_y)=>{
              y.question_list = y.question_list.map((x,index)=>{
                let return_data = {
                  ...x,
                  answer: null,
                  error: ''
                }
                if(x.guest_profile_preference_question.type != 'TEXT' && x.use_other){
                  x.preference_list.push({
                    id:`other_${index}`,
                    name: 'Other',
                    answer: ''
                  })
                }
                if(x.guest_profile_preference_question.type == 'TEXT'){
                  return_data.answer = ''
                }else if(x.guest_profile_preference_question.type == 'CHOICE'){
                  return_data.answer = {}
                }else if(x.guest_profile_preference_question.type == 'MULTIPLE_CHOICE'){
                  return_data.answer = []
                }
                return return_data
              })
              return y
            })

            setTimeout(() => {
              this.preference_load = false
            }, 500);
          }
        })
      },


      // PROCESS
      fillData(params){
        if(params.type == 'form'){
          this.general_form = params.data
          this.checkFormData('general')
        }else if(params.type == 'passport'){
          this.passport_list = params.data
          this.total_guest_selected = params.other_data
          if(this.getMerchant().precheckin_form_document_verification == 'REQUIRED'){
            this.checkFormData('img')
          }else{
            this.invalid_form.img = ''
            this.invalid_form.owner_img = ''
          }
        }else{
          this.owner_image = params.data
        }
      },
      checkFormData(params){
        if(params == 'general'){
            this.invalid_form.first_name = this.$v.general_form.first_name.$invalid ? 'required-first-name' : '';
            this.invalid_form.nationality = this.getMerchant().precheckin_form_nationality == 'REQUIRED' && this.$v.general_form.nationality.$invalid ? 'required-nationality' : '';
            this.invalid_form.day_of_birth = this.getMerchant().precheckin_form_day_of_birth == 'REQUIRED' && this.general_form.day_of_birth == 'Invalid date' ? 'invalid-date' : '';
            this.invalid_form.id_card_number = this.getMerchant().precheckin_form_id_card_number == 'REQUIRED' && this.$v.general_form.id_card_number.$invalid ? 'required-id-card-number' : '';

            if(this.general_form.id_card_is_lifetime) this.invalid_form.id_card_expired_date = ''
            else this.invalid_form.id_card_expired_date = this.getMerchant().precheckin_form_id_card_expired_date == 'REQUIRED' && this.general_form.id_card_expired_date == 'Invalid date' ? 'invalid-date' : '';

            if(this.$v.general_form.phone_number.$invalid){
              if(!this.$v.general_form.phone_number.required){
                this.invalid_form.phone_number = 'required-phone-number'
              }else{
                this.invalid_form.phone_number = 'invalid-phone-number'
              }
            }else{
              this.invalid_form.phone_number = ''
            }

            if(this.$v.general_form.email.$invalid){
              if(!this.$v.general_form.email.required){
                this.invalid_form.email = 'required-email'
              }else{
                this.invalid_form.email = 'invalid-email'
              }
            }else{
              this.invalid_form.email = ''
            }
            
            this.invalid_form.address = this.getMerchant().precheckin_form_address == 'REQUIRED' && this.$v.general_form.address.$invalid ? 'required-residence-address' : '';
            this.invalid_form.town = this.getMerchant().precheckin_form_town == 'REQUIRED' && this.$v.general_form.town.$invalid ? 'required-town' : '';
            this.invalid_form.post_code = this.getMerchant().precheckin_form_postcode == 'REQUIRED' && this.$v.general_form.postcode.$invalid ? 'required-post-code' : '';
            this.invalid_form.country = this.getMerchant().precheckin_form_country == 'REQUIRED' && this.$v.general_form.country.$invalid ? 'required-country' : '';
            this.invalid_form.visit_purpose = this.getMerchant().precheckin_form_purpose_of_visit == 'REQUIRED' && this.$v.general_form.visit_purpose.$invalid ? 'required-visit-purpose' : '';
            this.invalid_form.source_of_merchant_information = this.getMerchant().precheckin_form_source_of_merchant_information == 'REQUIRED' && this.$v.general_form.source_of_merchant_information.$invalid ? 'required-source-of-merchant-information' : '';
            this.invalid_form.allergy = this.getMerchant().precheckin_form_allergy == 'REQUIRED' && this.$v.general_form.allergy.$invalid ? 'required-allergy' : '';
            this.invalid_form.next_destination = this.getMerchant().precheckin_form_next_destination == 'REQUIRED' && this.$v.general_form.next_destination.$invalid ? 'required-nextdestination' : '';
        }
        if(params == 'img'){
          let total_file = this.passport_list.length
          if(this.getMerchant().precheckin_form_total_document_verification == 'BASED_ON_TOTAL_GUEST' && total_file < this.total_guest_selected){
            this.invalid_form.img = 'minimum-photo'
          }else if(this.getMerchant().precheckin_form_total_document_verification == 'MAX_ON_MAX_GUEST' && total_file == 0){
            this.invalid_form.img = 'photo-0'
          }else{
            this.invalid_form.img = ''
          }
        }

      },
      savePreferenceAnswer(data){
        if(data.is_other){
          this.preference_list[data.index_category].question_list[data.index].preference_list[this.preference_list[data.index].preference_list.length-1].answer = data.answer
        }else{
          this.preference_list[data.index_category].question_list[data.index].answer = data.answer
        }
      },
      validatePreference(){
        return new Promise((success,fail)=>{
          let once_error = false 
          this.preference_list = this.preference_list.map((preference_category, pc_index)=>{
            preference_category.question_list.map((question,q_index)=>{
              let is_answer_empty = typeof question.answer == 'object' ? Object.keys(question.answer).length == 0 ? true : false : !this.$isNotEmpty(question.answer)
              question.error = is_answer_empty ? 'This field is mandatory' : ''

              if(!once_error && is_answer_empty) once_error = true
              
              if(pc_index+1 == this.preference_list.length && q_index+1 == preference_category.question_list.length){
                if(once_error) fail()
                else success()
              }
              return question
            })
            return preference_category
          })
        })
      },
      
      // SUBMIT
      submitFormWithoutPreference(){
        return new Promise((success,fail)=>{
          this.pushing_data = true
          this.pushForm(false).finally(()=>{
            this.pushing_data = false
            success()
          })
        })
      },
      submitForm(){
        return new Promise((success,fail)=>{
          this.pushing_data = true
          if(this.form_step == 1){
            this.show_error_msg = false
            let validate_signature = this.getMerchant().precheckin_form_signature != 'REQUIRED' || (this.getMerchant().precheckin_form_signature == 'REQUIRED' && this.$refs.signature && !this.$refs.signature.isEmpty())
            this.invalid_signature = validate_signature ? '' : 'required-signature'

            let validate_img_owner = this.passport_list.length < 2 || (this.passport_list.length >= 2 && this.owner_image.file.name != '')
            this.invalid_form.owner_img = validate_img_owner ? '' : 'required'
            
            if(this.is_form_valid && validate_signature && validate_img_owner){
              if(this.preference_list.length > 0){
                if(this.getMerchant().guest_profile_preference_position === 'FIRST_PAGE'){
                  if(this.getMerchant().is_guest_profile_preference_required){
                    this.validatePreference()
                    .then(()=>{
                      this.pushForm().finally(()=>{
                        this.pushing_data = false
                        success()
                      })
                    })
                    .catch(()=>{
                      this.preference_key++
                      this.$smoothScroll('preference_first_page')
                      success()
                    })
                  }else{
                    this.pushForm().finally(()=>{
                      this.pushing_data = false
                      success()
                    })
                  }
                }else{
                  setTimeout(()=>{
                    document.getElementById('hotel-check-in').scrollIntoView({
                      behavior: 'smooth'
                    });
                  },100)
                  this.changeFormStep(2)
                  this.pushing_data = false
                  success()
                }
              }else{
                this.pushForm().finally(()=>{
                  this.pushing_data = false
                  success()
                })
              }
            } else {
              this.show_error_msg = true
              let scroll_id = ''
              if(!this.is_general_form_valid){
                scroll_id = 'general-form'
              }else if(this.invalid_form.img != '' || this.invalid_form.owner_img != ''){
                scroll_id = 'img-form'
              }else{
                scroll_id = 'term-form'
              }
              document.getElementById(scroll_id).scrollIntoView({
                behavior: 'smooth'
              });
              success()
            }
          }else{
            if(this.preference_list.length > 0 && this.getMerchant().guest_profile_preference_position  == 'SECOND_PAGE' && this.getMerchant().is_guest_profile_preference_required){
              this.validatePreference()
              .then(()=>{
                this.pushForm().finally(()=>{
                  this.pushing_data = false
                  success()
                })
              })
              .catch(()=>{
                this.preference_key++
                this.$smoothScroll('preference_second_page')
                success()
              })
            }else{
              this.pushForm().finally(()=>{
                this.pushing_data = false
                success()
              })
            }
          }
        })  
      },
      pushForm(with_preference=true){
        return new Promise((success,fail)=>{
          if(this.$route.query.folio == undefined){
            this.submitMainFolio(with_preference).finally(()=>{
              success()
            })
          }else{
            this.submitOtherFolio().finally(()=>{
              success()
            })
          }
        })
      },
      async processImages(image_file_list) {
        let image_data = [];
        for (let i = 0; i < image_file_list.length; i++) {
          try {
            let img_data = await this.$compressImage(image_file_list[i].file);
            let img_list = "id_card_image_" + i;
            if (typeof img_data === 'object') {
              image_data.push({
                key: img_list,
                value: img_data
              });
            } else {
              console.log(img_data);
            }
          } catch (error) {
            console.error(error);
          }
        }

        return image_data;
      },

      submitMainFolio(with_preference=true){
        return new Promise(done=>{
          this.push_loading = true
          this.error = ''
          var fd = new FormData();
          if(this.getMerchant().precheckin_form_signature != 'HIDE'){
            this.saveSignature()
          }
          // FILL PARAMS DATA
          let params = this.general_form
          params.prefix_name = this.general_form.prefix_name.toUpperCase()
          if(params.id_card_is_lifetime){
            params.id_card_expired_date = null
          }

          if(this.getMerchant().precheckin_form_id_card_expired_date == 'HIDE'){
            params.id_card_expired_date = ''
          }

          if(this.passport_list.length == 1){
            params.id_card_image_index = 0
          }else{
            let img_i = this.passport_list.findIndex(x=>x.file.name == this.owner_image.file.name)
            params.id_card_image_index = img_i != -1 ? img_i : 0
          }
          
          params.total_guest = this.total_guest_selected
          params.signature_image = this.getMerchant().precheckin_form_signature == 'HIDE' ? null : this.signature_image
          params.allow_email_marketing = this.marketing
          params.guest_preference = []
          if(with_preference){
            this.preference_list.forEach((item_category,index_category)=>{
              item_category.question_list.forEach((item,index)=>{
                let params_preference = {
                  preference: null,
                  preference_other: null,
                  preference_question: item.id
                }
                let other_option_id = `other_${index}`
                if(item.guest_profile_preference_question.type == 'TEXT'){
                  if(item.answer != ''){
                    params_preference.preference_other = item.answer
                    params.guest_preference.push(params_preference)
                  }
                }else if(item.guest_profile_preference_question.type == 'CHOICE'){ 
                  if(item.answer.id){
                    if(item.answer.id == other_option_id){
                      params_preference.preference_other = item.answer.answer
                    }else{
                      params_preference.preference = item.answer.id
                    }
                    params.guest_preference.push(params_preference)
                  }
                }else{
                  item.answer.forEach((ans_item,i)=>{
                    params_preference.preference_other = null
                    params_preference.preference = null
                    if(ans_item.id == other_option_id){
                      params_preference.preference_other = ans_item.answer
                    }else{
                      params_preference.preference = ans_item.id
                    }
                    let params_preference_clone = this.$deepCopy(params_preference)
                    params.guest_preference.push(params_preference_clone)
                  })
                }
              })
            })
          }
          // fd.append("form_data",JSON.stringify(params))
          // COMPRESS ID CARD IMAGE
          let image_file_list = this.passport_list.filter(x => x.file != null);
          if(image_file_list.length > 0){
            this.processImages(image_file_list)
            .then((result) => {
              fd.append("form_data",JSON.stringify(params))
              result.forEach((item,item_i)=>{
                fd.append(item.key,item.value,item.value.name)
                if(item_i+1 == result.length){
                  this.pushMainFolio(fd).finally(()=>{
                    done()
                  })
                }
              })
            })
            .catch((error) => {
              console.error(error);
              done()
            })
          }else{
            fd.append("form_data",JSON.stringify(params))
            this.pushMainFolio(fd).finally(()=>{
              done()
            })
          }
        })
      },
      pushMainFolio(fd){
        return new Promise(done=>{
          post("CONCIERGE",`booking/${this.auth.booking_number}/${this.$route.params.pms_detail_id}/save-form?merchant_id=${this.getMerchant().id}`,fd,{ type:'concierge_token_direct', token:this.auth.token}).then(response=>{
            let res = response.data
            if(res.success){
              let params_vuex = [
                {
                  key : 'booking_number',
                  value: this.auth.booking_number
                },
                {
                  key : 'token',
                  value: this.auth.token
                },
                {
                  key : 'detail_id',
                  value: this.$route.params.pms_detail_id
                },
                {
                  key : 'folio',
                  value: this.selected_room.folio_number
                }
              ]
              this.setReservationActive(params_vuex)
              if(this.getMerchant().use_precheckin_submit_landing_page){
                this.show_message_success = true
              }else{
                this.goToHomePage()
              }
            }else{
              this.error = res.message
            }
            this.push_loading = false
            done()
          })
        })
      },
      submitOtherFolio(){
        return new Promise(done=>{
          this.push_loading = true
          this.error = ''

          // FILL PARAMS DATA
          let params = {
            name: this.general_form.first_name+' '+this.general_form.last_name,
            gender: this.general_form.title == 'mr' ? 'MALE' : 'FEMALE',
            phone: this.general_form.phone_number,
            email: this.general_form.email,
            day_of_birth: '',
            identity_number: '',
            country: '',
            nationality: ''
          }

          let param_url = this.$route.query.folio == 'new' ? 'add-new' : `${this.$route.query.folio}/claim`
          let merchant_id = 'merchant_id='+this.getMerchant().id
          post("CONCIERGE",`reservation/${this.$route.params.pms_detail_id}/folio/${param_url}?${merchant_id}`,params).then(response=>{
            let res = response.data
            if(res.success){
              this.show_success_submit_other_folio = true
            }else{
              this.error = res.message
            }
            this.push_loading = false
            done()
          })
        })
      },


      // OTHER
      toggleWarning(){
        this.warning.show = !this.warning.show
      }, 
      changeReservation(){
        return new Promise((success,fail)=>{
          this.setReservationActive('reset')
          setTimeout(()=>{
            this.validateReservationData()
            this.warning = {
              show: false,
              title: '',
              body: '',
              type: 'default'
            }
            success()
          },300)
        })
      },
      changeFormStep(next_step){
        this.form_step = next_step
      },
      goToHomePage(){
        this.$router.push(`/${this.getMerchant().code}`)
      },
      newReservation(){
        let params = [
          {
            key : 'booking_number',
            value: this.$route.query.booking_number
          },
          {
            key : 'token',
            value: this.$route.query.token
          }
        ]
        this.setConciergeAuth(params)
        this.loadRoomData()
      },
      loadRoomData(){
        this.reservation_active = false
        this.active_room_type = ''
        this.is_load_room = true
        get("CONCIERGE",`booking/${this.getConciergeAuth().booking_number}/${this.$route.params.pms_detail_id}`,{
          merchant_id: this.getMerchant().id
        },'concierge_token').then(response=>{
          let res = response.data
          if(res.success){
            this.setConciergeAuth([
              {
                key : 'detail_id',
                value: this.$route.params.pms_detail_id
              }

            ])
            if(res.data.status =='NEW_RESERVATION'){
              this.selected_room = res.data
              this.total_max_guest = this.getMerchant().precheckin_form_total_document_verification == 'BASED_ON_TOTAL_GUEST' ? Number(res.data.adult)+Number(res.data.child) : Number(this.selected_room.room_type.max_guests)
              this.header_data = {
                merchant: this.getMerchant(),
                detail:{
                  check_in: res.data.arrival_date,
                  check_out: res.data.departure_date,
                  adult: res.data.adult,
                  child: res.data.child,
                  special_request: res.data.special_request
                },
                guest: res.data.booked_by,
                total_rooms: 0,
                room_type: this.$isNotEmpty(res.data.room_type) ? res.data.room_type.name : 'Unallocated Room Type'
              }
              this.show_form = true
            }else{
              this.goToHomePage()
            }
          }else{
            this.error = res.message
          }
          this.is_load_room = false
        })
      },
      toggleLanguage(data){
        this.language = data
      },
      saveSignature(){
        var _this = this;
        var image = new Image();
        var png = _this.$refs.signature.save()
        image.src = 'data:image/png;base64,iVBORw0K...';
        image.className = 'd-none'
        document.body.appendChild(image);
        this.signature_image = png
      },
      clearSignature(){
        var _this = this;
        _this.$refs.signature.clear();
      },
      undoSignature(){
        var _this = this;
        _this.$refs.signature.undo();
      },
      termCondition(){
        this.term_conditions = !this.term_conditions
        if (this.term_conditions) {
          this.term_conditions_data = true
        }
      },
      toggleMarketing(){
        this.marketing = !this.marketing
      },
      togglePopUp(data){
        this.term_conditions_data = data
      },
      toggleSuccessMessage(){
        this.show_message_success = !this.show_message_success
      },
      previousStepFromPreference(){
        document.getElementById('general-form').scrollIntoView({
          behavior: 'smooth'
        });
        this.form_step = 1
      }
		}
	}
</script>
<style scoped>
  .popup-box{
    position: fixed;
    height: 100vh;
    width: 100%;
    z-index: 9999;
    top: 0;
    left: 0;
    bottom: 0;
  }
  .popup-box-bg{
    background-color: rgba(0,0,0,.5)!important;
  }
  .mobile-none-c{
    display: block;
  }
  .mobile-block{
    display: none;
  }

	@media screen and (max-width: 655px) {
		.mobile-none-c{
			display: none !important;
		}
    .mobile-block{
      display: block !important;
    }
	}
  .border-green {
    border: 1px solid #79A33A !important;
  }

  .top-6px{
    top: 6px!important;
  }

  .h-check-in{
    height: 100vh;
    min-height: 100%
  }

  .border-x-semi-grey{
    border-left: 1px solid #DDDDDD !important; 
    border-right: 1px solid #DDDDDD !important; 
  }

</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/PreCheckinForm.vue